import Grid from "@mui/material/Grid";
import WorkItemSearchFieldStatus from "../fields/WorkItemSearchFieldStatus";
import Button from "@mui/material/Button";
import { BulkUpdateModes } from "../WorkItemBulkUpdate";

interface IBulkUpdateOpertionsStatus  {
    idSuffix: string,
    statusOptions: any[],
    disabled: boolean,
    onBulkUpdateStatusChange: (e: number[]) => void
    onUpdateGridClick: any
}

const BulkUpdateOpertionsStatus = (props: IBulkUpdateOpertionsStatus) => {
    return (
        <>
        <Grid xs={1} sm={1} md={12} lg={12}>
                        <h2>Bulk Update Operations</h2>
                        <h4>Apply the action to the selected rows (marked with the checkbox) in the grid above</h4>
                        <p>Assign status to selected rows</p>
                    </Grid>

                    <Grid xs={1} sm={1} md={6} lg={4}>
                        <WorkItemSearchFieldStatus
                            idSuffix={props.idSuffix}
                            multiple={false}
                            onChange={props.onBulkUpdateStatusChange}
                            options={props.statusOptions} />
                    </Grid>
                    <Grid xs={1} sm={1} md={2} lg={2} sx={{ mt: '24px' }}>
                        <Button
                            id={"bulk-update-ops-update-grid-"+props.idSuffix}
                            sx={{ marginRight: '10px', height: '40px' }}
                            variant="contained"
                            disabled={props.disabled}
                            onClick={props.onUpdateGridClick}>Update Grid</Button>
                    </Grid>
        </>        
    );
}

export default BulkUpdateOpertionsStatus;